


































































import FastAverageColor from "fast-average-color";
import Color from "color";
import { defineComponent, type PropType, isVue2 } from "vue-demi";
import type { CategoryNested } from "@constructor/shared-entity/type";

export default defineComponent({
  name: "GGCategoryGrid",
  props: {
    list: {
      type: Array as PropType<CategoryNested[]>,
      default: () => [],
    },
  },
  data(): { color: string[]; active: boolean } {
    return {
      color: [],
      active: false,
    };
  },
  computed: {
    count() {
      return this.list.length;
    },
    largeCount() {
      if (this.count >= 7) {
        return 1;
      } else {
        return 0;
      }
    },
  },
  mounted() {
    this.calculate();
  },
  methods: {
    calculate() {
      if (Array.isArray(this.$refs.img)) {
        const fac = new FastAverageColor();
        for (const [index, el] of this.$refs.img.entries()) {
          fac
            .getColorAsync(el as HTMLImageElement, {
              algorithm: "sqrt",
              ignoredColor: [
                [255, 255, 255, 170],
                [0, 0, 0, 255, 170],
              ],
            })
            .then((color) => {
              let c = Color(color.rgb);
              if (c.isDark()) {
                c = c.fade(0.5);
              }
              c = c.saturate(1).lightness(96);
              if (isVue2) {
                this.$set(this.color, index, c.rgb().toString());
              } else {
                this.color[index] = c.rgb().toString();
              }
            })
            .catch((e) => {
              if (isVue2) {
                this.$set(this.color, index, "#f8f8f8");
              } else {
                this.color[index] = "#f8f8f8";
              }
              throw Error(e);
            });
        }
      }
    },
  },
});
